"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var react_dnd_1 = require("react-dnd");
var Speise_1 = require("../Speise");
var style = {
    cursor: 'move',
    width: '100%'
};
var CustomDragItem = function (_a) {
    var id = _a.id, dish = _a.dish, index = _a.index, categorie = _a.categorie, moveItem = _a.moveItem, type = _a.type, additive = _a.additive, changeEvent = _a.changeEvent, deleteDishEvent = _a.deleteDishEvent, isAdmin = _a.isAdmin;
    var ref = react_1.useRef(null);
    var _b = react_dnd_1.useDrop({
        accept: type,
        hover: function (item, monitor) {
            if (!ref.current) {
                return;
            }
            var dragIndex = item.index;
            var hoverIndex = index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }
            var hoverBoundingRect = ref.current.getBoundingClientRect();
            var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            var clientOffset = monitor.getClientOffset();
            var hoverClientY = clientOffset.y - hoverBoundingRect.top;
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }
            moveItem(dragIndex, hoverIndex, item.id);
            item.index = hoverIndex;
        }
    }), drop = _b[1];
    var _c = react_dnd_1.useDrag({
        item: { type: type, id: id, index: index },
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging(),
        }); },
    }), isDragging = _c[0].isDragging, drag = _c[1];
    var opacity = isDragging ? 0 : 1;
    drag(drop(ref));
    return (React.createElement("div", { ref: ref, style: __assign(__assign({}, style), { opacity: opacity }) },
        React.createElement(Speise_1.default, { index: index, dish: dish, categorie: categorie, deleteDishEvent: deleteDishEvent, changeEvent: changeEvent, isAdmin: isAdmin, additive: additive })));
};
exports.default = CustomDragItem;
//# sourceMappingURL=CustomDragItem.js.map